import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/life-at-kingston/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="eca">
    <h1>Extra Curricular Activities</h1>
    <p>
      In order to continue to allow students to develop skills and interests beyond the classroom, we have developed a
      comprehensive daily Extra Curricular Activity Programme which takes place after school. Only Kingston students are
      permitted to enrol in our ECA classes.
    </p>
    <table>
      <thead>
        <tr>
          <th className="center" style={{ width: '50%' }}>
            Kingston International School
          </th>
          <th className="center" style={{ width: '50%' }}>
            Kingston International Kindergarten
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="center">3:30pm – 4:30pm </td>
          <td className="center">4:45pm – 5:45pm</td>
        </tr>
      </tbody>
    </table>
    <h4>What We Offer</h4>
    <ul className="list">
      <li>Putonghua and English options</li>
      <li>Monday to Friday classes available</li>
      <li>Three ECA cycles a school year</li>
      <li>School holiday programmes including a comprehensive summer ECA programme</li>
      <li>ECAs taught by Kingston teachers and outside agencies</li>
      <li>
        A variety of ECAs which have included – Floor Hockey, Basketball, Football, Phonics, Drama, Art, Coding and
        other ICT, Chess, Martial Arts, Taekwondo, Cooking, Science, Ukulele, Spanish, etc
      </li>
    </ul>
    <p>Costs are dependent on ECA</p>
  </ContentLayout>
);
